import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import CustomVideoPlayer from '../../../src/components/custom-video-player';
import ComponentLayout from '../../../src/layouts/component-layout';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h2>{`Anatomy`}</h2>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/6951037/14759331-3908-4eaf-9d67-db594b2407f0",
        "alt": "An image displaying a hero with a heading, description, primary and secondary actions."
      }}></img></p>
    <ul>
      <li parentName="ul">{`Label: an optional label to provide leading context to the hero.`}</li>
      <li parentName="ul">{`Heading: the main title of the hero.`}</li>
      <li parentName="ul">{`Description: a short description of the hero.`}</li>
      <li parentName="ul">{`Actions: the main and secondary actions the user should take on the page.`}</li>
      <li parentName="ul">{`Image: an optional foreground image that appears adjacent to the text`}</li>
    </ul>
    <h2>{`Usage`}</h2>
    <p>{`Use the hero component to provide a title, description and action that introduces the main content of a page. The hero component is designed to be positioned at the top of a page and spans the full width of the viewport. Consider using the `}<a parentName="p" {...{
        "href": "/brand/components/CTABanner"
      }}>{`CTA banner`}</a>{` to replicate the content and actions in other parts of the page.`}</p>
    <p>{`Both the heading and description of the hero should be concise and descriptive. The heading should not exceed two lines, and the description should be limited to 3–4 lines.`}</p>
    <p>{`The description must maintain a minimum contrast ratio of 4.5:1 at all times. Since it may appear in either the `}<inlineCode parentName="p">{`default`}</inlineCode>{` or `}<inlineCode parentName="p">{`muted`}</inlineCode>{` text colors, ensure the `}<inlineCode parentName="p">{`muted`}</inlineCode>{` variant is used only when contrast is sufficient and no background imagery is present.`}</p>
    <p>{`The hero component is not designed to provide a lot of information to the user. Consider using other components, such as the `}<a parentName="p" {...{
        "href": "/brand/components/SectionIntro"
      }}>{`section intro`}</a>{` or the `}<a parentName="p" {...{
        "href": "/brand/components/River"
      }}>{`river`}</a>{` component instead.`}</p>
    <p>{`The hero heading is rendered as an `}<inlineCode parentName="p">{`h1`}</inlineCode>{` element by default. You can modify the heading level but be aware that this will affect the page's heading structure and may impact accessibility. `}<a parentName="p" {...{
        "href": "/brand/components/Heading#accessibility"
      }}>{`See heading accesibility`}</a>{` for more information.`}</p>
    <p>{`The hero can optionally include primary and secondary actions. These actions are rendered as a `}<a parentName="p" {...{
        "href": "/brand/components/ButtonGroup"
      }}>{`button group`}</a>{` and follow the same guidelines as the button group component.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/6951037/7ea1041a-6b3e-4a7c-a7da-a889ee642023" />
    <Caption mdxType="Caption">
      Use the hero component to introduce the page with short, descriptive text.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/6951037/ed440ce6-a708-4196-b40b-30a2b6f03c13" />
    <Caption mdxType="Caption">
      Don't use long, complex text in the hero. Consider splitting the content
      using other components.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Options`}</h2>
    <h3>{`Alignment`}</h3>
    <p>{`Hero elements can be aligned to the start or center of the page. By default, the hero is aligned to the start of the page to allow for an image or a visual asset to be positioned on the right of the hero. Use the center alignment if the asset is centered or not present, or the scenario calls for it.`}</p>
    <DoDontContainer stacked mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/6951037/d3ce9fb3-e455-4535-8613-72d52d8961dc" />
    <Caption mdxType="Caption">
      Use left alignment if the hero includes an image or visual asset on the
      right.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/6951037/4e3db6e1-cdb8-4a1e-a81c-b22f431b0738" />
    <Caption mdxType="Caption">
      Don't use center alignment if the background interfere with the legibility
      of the content.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/SectionIntro"
        }}>{`Section intro`}</a>{`: To provide a title, description and a link to a new section in the page.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/River"
        }}>{`River`}</a>{`: To display a list of content items with a visual asset.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/CTABanner"
        }}>{`CTABanner`}</a>{`: To draw attention to or create urgency around a user action.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      